module.exports = __webpack_public_path__ + "static/media/unlock.8adef558.svg";